module.exports = __webpack_public_path__ + "img/ios.f1ac05c2.png";